import axios from "axios"
import Repository from "../../repositories/Repository"

const getDefaultState = () => {
  return {
    isLoggedIn: false,
    token: null,
  }
}

const state = getDefaultState()

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  getToken: state => state.token,
}

const mutations = {
  auth: (state, { data }) => {
    state.isLoggedIn = true
    state.token = data.token
  },

  logout: state => {
    state.isLoggedIn = false
    state.token = null
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const setName = (nameType, displayName) => {
  console.log("Display name in setName is ", displayName)
  // let firstName,lastName,middleName = '';
  const displayNameArray = displayName.split(" ")
  console.log("displayNameArray is ", displayNameArray)
  const [firstName, lastName] = displayNameArray
  console.log("First and last name is ", firstName, lastName)

  if (nameType === "first") return firstName
  else if ((nameType = "last")) return lastName
  else return middleName
}

const actions = {
  login: async ({ commit }, payload) => {
    // Call LOGIN API
    const res = await axios.post(`${process.env.BASE_API_URL}/login/`, payload.data)
    const userData = {
      user: { ...res.data.data, multiRole: res.data.data.role },
    }
    commit("User/setUser", { data: userData }, { root: true })
  },

  ssoLogin: async ({ commit }, payload) => {
    // Call SSO LOGIN API
    console.log("store - Auth.js - ssoLogin() - payload:", payload)
    try {
      const res = await axios.post(`${process.env.BASE_API_URL}/ssologin/`, payload.circleAuth).catch(e => {
        const payload = {
          user: { ...e.response.data.data },
        }
        return Promise.reject({
          response: { data: { data: payload } },
        })
      })
      if (res) {
        console.log("Response data in ssoLogin", res.data.data)
        localStorage.setItem("token", payload.circleAuth.dtoken)
        localStorage.setItem("delete_all", res.data.data.is_deactivate)
        const userData = {
          user: { ...res.data.data, multiRole: res.data.data.role },
        }
        userData.user.url = null
        // console.log('User data in ssoLogin before setting first last name', userData)
        // userData.first_name = setName('first', userData.user.display_name),
        // userData.middle_name = setName('middle', userData.user.display_name),
        // userData.last_name = setName('last', userData.user.display_name),
        // console.log('User data in ssoLogin after setting first last name', userData)
        commit("User/setUser", { data: userData }, { root: true })
      }
    } catch (e) {
      const userObject = { ...e.response.data.data.user }
      // console.log('User data in ssoLogin in catch before setting first last name', userObject)
      // userObject.first_name = setName('first', userObject.display_name),
      // userObject.middle_name = setName('middle', userObject.display_name),
      // userObject.last_name = setName('last', userObject.display_name),
      // console.log('User data in ssoLogin in catch after setting first last name', userObject)
      commit("User/setUser", { data: { user: { ...e.response.data.data.user } } }, { root: true })
      // commit(
      //   "User/setUser",
      //   {
      //     data: {
      //       user: {
      //         email: "askjdnajskd",
      //         verified_account: false,
      //         firstName: "asd",
      //         display_name: "asd a"
      //       }
      //     }
      //   },
      //   { root: true }
      // );
      const unverified = {
        email: e.response.data.data.user.email,
        isVisible: true,
      }

      commit("App/setMail", unverified)
    }
  },

  register: async (_, payload) => {
    await axios.post(`${process.env.BASE_API_URL}/dovemedregister/`, payload.data)
  },

  logout: ({ dispatch, commit }) => {
    commit("User/resetState", null, { root: true })
    localStorage.clear()
  },

  resetAuthState({ commit }) {
    commit("resetState")
  },

  adminLogin: async ({ commit }, payload) => {
    try {
      const res = await axios.post(`${process.env.BASE_API_URL}/${payload.type}/`, payload.data)
      if (res && res.data && res.data.results) {
        return res.data.results[0]
      }
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth.js